<div class="wrapper--spacing-horizontal">
  @if (isLoaded()) {
    <app-fertilizers-table
      [fertilizers]="initialStockFertilizers"
      title="initialStock"
      [showManureCode]="true"
      [manureTypeDetails]="true"
      [showInitialStockMatchesRvo]="true"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="notDeliveredFertilizers"
      title="isNotDelivered"
      [showManureCode]="true"
      [manureTypeDetails]="true"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="deliveredFertilizers"
      title="isDelivered"
      [showManureCode]="true"
      [manureTypeDetails]="true"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="dispatchedFertilizers"
      title="dispatched"
      [showManureCode]="true"
      [manureTypeDetails]="true"
    ></app-fertilizers-table>

    <app-fertilizers-table
      [fertilizers]="closingStockFertilizers"
      title="closingStock"
      [showManureCode]="true"
      [manureTypeDetails]="true"
    ></app-fertilizers-table>

    <h3 class="text--h5">{{ 'comments' | translate }}</h3>
    <app-fertilizer-comment></app-fertilizer-comment>
  }
</div>
